<template>
  <div>
    <header-component />
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header">
          <h3 class="mb-0" style="text-transform: capitalize">Product List</h3>
          <div class="col-lg-12 col-5 text-right">
            <div class="table-filters">
              <el-tag
                v-for="(tag, index) in filters"
                :key="index"
                :disable-transitions="false"
                closable
                @close="removeFilter(index)"
              >
                <span v-if="tag">
                  {{ tag.field }}:
                  <span style="font-weight: bold">
                    {{ tag.value }}
                    <span />
                  </span>
                </span>
              </el-tag>
            </div>

            <el-popover
              v-model="filterPopUpVisible"
              placement="left"
              width="550"
              class="filters"
            >
              <table-filter @apply="applyFilters" />
              <base-button slot="reference" size="sm" type="primary"
                >Add Filter</base-button
              >
            </el-popover>
            <base-button
              size="sm"
              type="primary"
              class="export-button"
              @click="handleProductExport()"
              >Export Products</base-button
            >
            <base-button
              size="sm"
              type="primary"
              class="export-button"
              @click="handleProductImport()"
              >Import Products</base-button
            >
          </div>
        </div>
        <el-table
          :data="tableData"
          class="table-responsive table-flush"
          header-row-class-name="thead-light"
        >
          <el-table-column label="Product Name">
            <template slot-scope="scope">{{ scope.row.name }}</template>
          </el-table-column>
          <el-table-column label="HSN">
            <template slot-scope="scope">{{ scope.row.hsn }}</template>
          </el-table-column>
          <el-table-column label="MRP">
            <template slot-scope="scope">{{ scope.row.mrp }}</template>
          </el-table-column>
          <el-table-column label="Barcode">
            <template slot-scope="scope">{{ scope.row.barcode }}</template>
          </el-table-column>
          <el-table-column label="Quantity" prop="quantity" />
          <el-table-column label="Tax Name">
            <template slot-scope="scope">{{ scope.row.tax.label }}</template>
          </el-table-column>
          <el-table-column min-width="70px">
            <template slot-scope="scope">
              <el-dropdown
                @command="command => handleAction(scope.row, command)"
              >
                <el-button type="primary" size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu
                  slot="dropdown"
                  class="dropdown-menu dropdown-menu-arrow show"
                >
                  <el-dropdown-item command="edit">Edit</el-dropdown-item>
                  <el-dropdown-item command="barcode"
                    >Print Barcode</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <div class="card-footer">
          <div
            v-if="meta"
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                Showing {{ meta.from + 1 }} to {{ meta.to }} of
                {{ meta.total }} entries
                <span v-if="selectedRows.length"
                  >&nbsp; &nbsp; {{ selectedRows.length }} rows selected</span
                >
              </p>
            </div>
            <pagination :meta="meta" @paginate="setPagination" />
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="showImportFileModal"
      title="Upload Products"
      width="30%"
    >
      <el-upload
        action
        class="upload-demo"
        :on-change="handleFileUpload"
        :file-list="fileList"
        show
        :auto-upload="false"
      >
        <el-button size="small" type="primary" :loading="isFileUploadingLoader">
          <span v-if="isFileUploadingLoader">Loading </span>
          <span v-else>
            Click to upload
          </span>
        </el-button>

        <div slot="tip" class="el-upload__tip">
          Only xlsx file is allowed
        </div>
      </el-upload>
    </el-dialog>
  </div>
</template>

<script>
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Button,
  Tag,
  Upload,
  Dialog
} from "element-ui";
import { mapGetters, mapActions, mapMutations } from "vuex";
import headerComponent from "../Components/HeaderComponent";
import pagination from "@/components/AmsaPagination";
import tableFilter from "@/components/TableFilterComponent";
import ProductFilter from "../../components/ProductTableFilter";
export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    [DatePicker.name]: DatePicker,
    [Upload.name]: Upload,
    [Dialog.name]: Dialog,
    "header-component": headerComponent,
    pagination,
    "table-filter-component": tableFilter,
    "table-filter": ProductFilter,
    [Tag.name]: Tag
  },
  data: () => {
    return {
      fileList: [],
      selectedRows: [],
      filters: {},
      visibleFilters: [],
      pageSize: 10,
      filterPopUpVisible: false,
      filters: [],
      showImportFileModal: false,
      isFileUploadingLoader: false
    };
  },

  computed: {
    ...mapGetters({
      products: "product/getProducts"
    }),
    tableData() {
      return this.products.rows;
    },
    meta() {
      return this.products.meta;
    }
  },

  watch: {
    filters: {
      deep: true,
      handler: function(value, oldValue) {
        this.restructureFilters(value);
      }
    }
  },

  mounted() {
    const data = window.localStorage.getItem("productFilters");
    const parsedData = JSON.parse(data);
    if (data != null && parsedData.length != 0) {
      if (parsedData.length > 1) {
        const list = parsedData;
        this.filters.push(...list);
      } else {
        this.filters.push(...parsedData);
      }
    } else {
      this.paginate();
    }
  },

  methods: {
    ...mapActions({
      getProducts: "product/getProducts",
      getProduct: "product/getProduct",
      exportProductList: "product/exportProductList",
      importProductFile: "product/importProductFile"
    }),
    ...mapMutations({ setBarcode: "product/setBarcode" }),
    handleAction(product, command) {
      if (command === "edit") {
        this.getProduct(product.productId);
        this.$router.push("/products/add/" + product.productId);
      }
      if (command === "barcode") {
        this.setBarcode(product.barcode);
        this.showBarcode();
      }
    },
    showBarcode() {
      this.$router.push("/products/barcode");
    },
    setPagination(data) {
      this.pageSize = data.perPage;
      this.restructureFilters(this.filters, data.page);
    },
    paginate(page = 1, filters = {}) {
      let query = {
        page,
        perPage: this.pageSize,
        ...filters
      };
      this.getProducts(query);
    },
    applyFilters(filters) {
      if (filters.length > 1) {
        this.filters.push(...filters);
      } else {
        this.filters.push(filters);
      }
      window.localStorage.setItem(
        "productFilters",
        JSON.stringify(this.filters)
      );
      this.filterPopUpVisible = false;
    },
    removeFilter(tagIndex) {
      if (
        this.filters[tagIndex].field === "attribute" ||
        this.filters[tagIndex].field === "value"
      ) {
        const selectedItem = this.filters.find(
          (_, index) => index === tagIndex
        );
        const item = this.filters.find(i => i.type === selectedItem.type);
        this.filters.splice(tagIndex, 1);
        const index = this.filters.indexOf(item);
        this.filters.splice(index, 1);
      } else {
        this.filters.splice(tagIndex, 1);
      }
      if (this.filters.length > 0) {
        window.localStorage.setItem(
          "productFilters",
          JSON.stringify(this.filters)
        );
      } else {
        window.localStorage.removeItem("productFilters");
      }
    },
    restructureFilters(value, page = 1) {
      const filtered = {};
      value.forEach(i => {
        if (typeof i.value != "undefined") {
          filtered[i.field] = i.value;
        }
      });
      if (Object.entries(filtered).length > 0) {
        this.paginate(page, filtered);
      } else {
        this.paginate(page);
      }
    },
    handleProductExport() {
      const query = {};
      this.filters.forEach(i => {
        if (typeof i.value != "undefined") {
          query[i.field] = i.value;
        }
      });
      this.exportProductList(query).then(res => {
        const url = URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.ms-excel"
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "products");
        document.body.appendChild(link);
        link.click();
        this.$notify({
          message: "Products Exported Successfully",
          type: "success",
          title: "Success"
        });
      });
    },

    handleProductImport() {
      this.showImportFileModal = true;
    },
    handleFileUpload(file) {
      this.isFileUploadingLoader = true;
      const fileType = file.raw.name.split(".").pop();
      if (fileType === "xlsx" || fileType === "xls") {
        this.importProductFile(file.raw)
          .then(() => {
            this.isFileUploadingLoader = false;
            this.showImportFileModal = false;
            this.getProducts();
            this.$notify({
              showClose: true,
              message: "File uploaded successfully!",
              type: "success",
              title: "Success"
            });
          })
          .catch(() => {
            this.isFileUploadingLoader = false;
          });
      } else {
        this.$notify({
          showClose: true,
          message: "File Should Be Of type xlsx!",
          type: "error",
          title: "Error"
        });
      }
    }
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
.table-filters {
  display: inline-block;
}
.table-filters .el-tag {
  margin-left: 10px;
}
.filters {
  margin-right: 8px;
  margin-left: 8px;
}
</style>
